import { defineComponent as _defineComponent } from 'vue'
import { computed, getCurrentInstance, onMounted, ref } from 'vue';
import router from '@/router';
import store from '@/store';
import i18n from '@/i18n';
import { RouteNames } from '@/enums/routes/RouteNames';
import { LoadingOverlayHelper } from '@/helpers/LoadingOverlayHelper';
import Dashboard from '@/modules/Statistics/api/models/Dashboard';
import DashboardRepository from '@/modules/Statistics/api/repositories/DashboardRepository';
import SettingsTopBar from '@/modules/CMS/layout/SettingsTopBar.vue';
import { useUserRights } from '@/shared/composables/useUserRights';


export default /*#__PURE__*/_defineComponent({
  __name: 'Dashboards',
  setup(__props) {

const { proxy } = getCurrentInstance()!;
const filteredDashboards = ref<any>(null);
const loadingOverlay = new LoadingOverlayHelper(proxy as any, {});

const columns = computed(() => [
    { title: 'Id', dataIndex: 'id', key: 'id' },
    { title: i18n.t('Reports'), dataIndex: 'reports', key: 'reports' },
]);

// Fetched dashboards / dummy data
const dashboards = computed(() => {
    const dashboardList = DashboardRepository.getAll();
    return dashboardList.map((dashboard: Dashboard) => {
        return {
            key: dashboard.id,
            id: dashboard.id,
            reports: dashboard.dashboardReports.length,
        };
    });
});

const temporaryCmsUserData = computed(() => store.getters['temporaryCmsData/cmsUser']);

function navigateToCurrentUsersDashboard() {
    router.push({ name: RouteNames.statisticsDashboard });
}

function navigateToDashboard(id: string) {
    router.push({ name: RouteNames.statisticsDashboard, params: { dashboardId: id } });
}

function onSearch(query: string) {
    filteredDashboards.value = dashboards.value.filter((item: any) => {
        return item.id.includes(query.toLowerCase());
    });
}

async function fetchAllDashboards() {
    try {
        await Dashboard.getAll();
    } catch (error) {
        return Promise.reject(error);
    }
}

onMounted(async () => {
    loadingOverlay.start();

    try {
        await Promise.allSettled([fetchAllDashboards()]);
    } finally {
        loadingOverlay.stop();
    }
});

return { __sfc: true,proxy, filteredDashboards, loadingOverlay, columns, dashboards, temporaryCmsUserData, navigateToCurrentUsersDashboard, navigateToDashboard, onSearch, fetchAllDashboards, SettingsTopBar }
}

})